import axios, { AxiosResponse, AxiosRequestConfig } from 'axios';
import { getClientId, getLocationId } from '.';
import { SESSION_KEY_JWT } from '../constants';

const eventsApiUrl = import.meta.env.VITE_EVENTS_API_URL;

export async function eventsRequest<T>(
    url: string,
    method: 'get' | 'post' | 'put' | 'delete' | 'patch',
    data?: any
): Promise<AxiosResponse<T>> {
    const clientId = getClientId();
    const locationId = getLocationId();

    const jwtToken = localStorage.getItem(SESSION_KEY_JWT);
    const axiosConfig: AxiosRequestConfig = {
        baseURL: eventsApiUrl,
        headers: {
            'client_id': clientId,
            'Authorization': `Bearer ${jwtToken}`, // TODO don't send JWT if its null
            'location_id': locationId,
        },
    };

    try {
        const response = await axios.request<T>({
            url,
            method,
            data,
            ...axiosConfig,
        });
        return response;
    } catch (error) {
        throw error;
    }
}